@import "src/less/variables.less";

.footer {
  background-color: var(--dds-color-darker-red);
  width: 100%;
  height: var(--dds-spacing-large-120);
}
.footerInner {
  height: 100%;
  margin-left: 10%;
  margin-right: 10%;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.logoPosten {
  width: 15%;

  @media @dds-breakpoint-phone-only {
    width: 25%;
  }
}

.textContent {
  color: var(--dds-color-light-grey);
  height: 100%;
  align-content: center;
}

.innerText {
  display: flex;
  flex-direction: row;

  @media @dds-breakpoint-phone-only {
    display: flex;
    flex-direction: column;
  }
}
.innerText > p {
  margin-right: var(--dds-spacing-small-12);
}
.innerText > a {
  margin-right: var(--dds-spacing-small-12);
}

.link {
  color: var(--dds-color-light-grey);
}
